<template>
  <Layout class="app-layout">
    <LayoutHeader class="app-layout-header" :class="{ 'hide-thin-header': !pageAtTop }">
      <Header />
    </LayoutHeader>
    <LayoutContent class="app-layout-content">
      <router-view :fetchData="fetchData" />
    </LayoutContent>
    <LayoutFooter class="app-layout-footer">
      <Footer />
    </LayoutFooter>
  </Layout>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import Layout from 'ant-design-vue/lib/layout'
import Header from './header/index.vue'
import Footer from './footer/index.vue'
import { Throttle } from '@/utils/action'
import { useStoreHooks } from '@/store/hook'

export default defineComponent({
  components: {
    Layout,
    LayoutHeader: Layout.Header,
    LayoutFooter: Layout.Footer,
    LayoutContent: Layout.Content,
    Header,
    Footer
  },
  props: ['fetchData'],
  setup () {
    const pageAtTop = ref(true)
    const { state: storeState } = useStoreHooks()
    const languageList = computed(() => storeState.global.languageList)
    onMounted(() => {
      if (languageList.value.length > 1) {
        const onPageScroll = new Throttle().use(() => {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          pageAtTop.value = scrollTop === 0
        }, 200)
        document.addEventListener('scroll', onPageScroll)
      }
    })
    return {
      pageAtTop
    }
  }
})
</script>

<style lang="less" src="./index.less"></style>
